/** Different types of snackbar. The UI style varies based on the type. */
export enum SnackbarType {
    Info = 1,
    Warning = 2,
}